import { render, staticRenderFns } from "./ModalNewPago.vue?vue&type=template&id=72a55030&"
import script from "./ModalNewPago.vue?vue&type=script&lang=js&"
export * from "./ModalNewPago.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewPago.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports